import { useState, useEffect } from 'react';
import './SplashScreen.css';

export default function SplashScreen({ onFinish }) {
  const [progress, setProgress] = useState(0);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    // Smooth progress animation over 2.6 seconds
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          handleComplete();
          return 100;
        }
        return prev + 4;
      });
    }, 90);

    return () => clearInterval(interval);
  }, []);

  const handleComplete = () => {
    setIsFadingOut(true);
    setTimeout(() => {
      if (onFinish) onFinish();
    }, 2000);
  };

  const handleSkip = () => {
    handleComplete();
  };

  // Joyful emojis and celebration elements
  const joySymbols = ['🎉', '🛍️', '✨', '💖', '🎁', '⚡', '🌟', '🥳', '🙌', '🎈', '❤️', '🚀'];

  return (
    <div className={`splash-container ${isFadingOut ? 'splash-fade-out' : ''}`}>
      {/* CSS Background Spinning Sunburst Light Rays */}
      <div className="splash-sunburst-rays" />

      {/* Floating Confetti & Joy Particle Symbols */}
      <div className="splash-particles-container">
        {[...Array(24)].map((_, i) => (
          <div
            key={i}
            className={`splash-symbol-particle particle-index-${i % 6}`}
            style={{
              left: `${(i * 17 + 7) % 92}%`,
              animationDelay: `${(i * 0.25) % 2.5}s`,
              animationDuration: `${2.2 + (i % 4) * 0.4}s`
            }}
          >
            {joySymbols[i % joySymbols.length]}
          </div>
        ))}
      </div>

      {/* Main Glass Layout Box */}
      <div className="splash-content-wrapper">
        {/* Top Header Text */}
        <div className="splash-header-area">
          <h1 className="splash-main-title">Har Dukaan Ki</h1>
          <h2 className="splash-sub-title">Apni Pehchaan</h2>
        </div>

        {/* Center Logo Showcase with CSS Aura Rings */}
        <div className="splash-logo-stage">
          <div className="splash-aura-glow-outer" />
          <div className="splash-aura-glow-inner" />

          <img
            src="/shopaxo.png"
            alt="ShopAXO Logo"
            className="splash-center-logo"
          />
        </div>

        {/* Joyful Bouncing People Emoji Row */}
        <div className="splash-joy-characters">
          <span className="joy-char char-1">🙌</span>
          <span className="joy-char char-2">🥳</span>
          <span className="joy-char char-3">💖</span>
          <span className="joy-char char-4">🛍️</span>
          <span className="joy-char char-5">🥳</span>
          <span className="joy-char char-6">🙌</span>
        </div>

        {/* Footer Area with Tagline and CSS Loader */}
        <div className="splash-footer-area">
          <p className="splash-tagline">Discover Your Local Shop's Identity! ✨</p>

          <div className="splash-loader-box">
            <div className="splash-progress-track">
              <div
                className="splash-progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
            <span className="splash-loader-text">{progress}%</span>
          </div>
        </div>

        {/* Glassmorphic Skip Button */}
        <button
          type="button"
          className="splash-skip-button"
          onClick={handleSkip}
        >
          Skip
        </button>
      </div>
    </div>
  );
}
